export const config = {
  backendUrl: process.env.REACT_APP_BACKEND_URL as string,
  backendAuthToken: process.env.REACT_APP_BACKEND_AUTH_TOKEN as string,
  partnerKey: process.env.REACT_APP_PARTNER_KEY as string,
  xApiKey: process.env.REACT_APP_X_API_KEY as string,
  orderUrl: process.env.REACT_APP_ORDER_URL as string,
  orderType: process.env.REACT_APP_ORDER_TYPE as string,
  googleAddressKey: process.env.REACT_APP_GOOGLE_ADDRESS_KEY as string,
}